__turbopack_context__.v({
  "bar": "_5TlSfG_bar",
  "hairline": "_5TlSfG_hairline",
  "landing": "_5TlSfG_landing",
  "logoSlot": "_5TlSfG_logoSlot",
  "menuButton": "_5TlSfG_menuButton",
  "panelIn": "_5TlSfG_panelIn",
  "premiumTrigger": "_5TlSfG_premiumTrigger",
  "root": "_5TlSfG_root",
  "tools": "_5TlSfG_tools",
});
